"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _calendar = _interopRequireDefault(require("./calendar"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var coPropTypes = _interopRequireWildcard(require("../helpers/prop-types"));

var calendarHelper = _interopRequireWildcard(require("./calendar-helper"));

var _datepickerNavigation = _interopRequireDefault(require("./datepickerNavigation"));

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

var _lodash = _interopRequireDefault(require("lodash.isempty"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DateRangePicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DateRangePicker, _React$Component);

  function DateRangePicker(props) {
    var _this;

    _classCallCheck(this, DateRangePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateRangePicker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "isValidInterval", function (start, end) {
      var dateStart = calendarHelper.createLuxonDay(start);
      var dateEnd = calendarHelper.createLuxonDay(end);
      return dateStart.diff(dateEnd).values.milliseconds >= 0;
    });

    _defineProperty(_assertThisInitialized(_this), "overlapsDisabled", function (selectedDate) {
      var _this$state = _this.state,
          disabledIntervals = _this$state.disabledIntervals,
          startDate = _this$state.startDate;
      if (!selectedDate || !disabledIntervals.length) return false;
      var luxonStartDate = calendarHelper.createLuxonDay(startDate);
      var luxonEndDate = calendarHelper.createLuxonDay(selectedDate);
      var selectionInterval = calendarHelper.getDateRange(luxonStartDate, luxonEndDate);
      return !!disabledIntervals.find(function (interval) {
        return selectionInterval.overlaps(interval);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateDateRange", function (selectedDate) {
      var _this$state2 = _this.state,
          startDate = _this$state2.startDate,
          endDate = _this$state2.endDate;
      if ((0, _lodash.default)(startDate)) return _objectSpread({}, _this.state, {
        startDate: selectedDate
      });

      if ((0, _lodash.default)(endDate)) {
        var isValidInterval = _this.isValidInterval(selectedDate, startDate);

        if (!isValidInterval) return _objectSpread({}, _this.state, {
          startDate: selectedDate
        });

        var isOverlapped = _this.overlapsDisabled(selectedDate);

        if (isOverlapped) return _this.state;
        return _objectSpread({}, _this.state, {
          endDate: selectedDate
        });
      }

      return _objectSpread({}, _this.state, {
        startDate: selectedDate,
        endDate: {}
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateDatePicker", function (calendarNavigation) {
      _this.setState({
        month: parseInt(calendarNavigation.month),
        year: parseInt(calendarNavigation.year),
        pickingMonth: calendarNavigation.pickingMonth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (selectedDate) {
      var updatedRangeState = _this.updateDateRange(selectedDate);

      _this.setState(updatedRangeState, function () {
        _this.props.onChange({
          startDate: updatedRangeState.startDate,
          endDate: updatedRangeState.endDate
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (hoveredDate) {
      var currentHoveredDate = (0, _lodash.default)(_this.state.endDate) ? hoveredDate : {};

      _this.setState({
        hoveredDate: currentHoveredDate
      });
    });

    var currentDateTime = calendarHelper.getCurrentDateTime();

    var _ref = props.startDate ? calendarHelper.getDateInfo(props.startDate) : {},
        ignoredStartDate = _ref.date,
        _startDate = _objectWithoutProperties(_ref, ["date"]);

    var _ref2 = props.endDate ? calendarHelper.getDateInfo(props.endDate) : {},
        ignoredEndDate = _ref2.date,
        _endDate = _objectWithoutProperties(_ref2, ["date"]);

    var _hoveredDate = calendarHelper.getDateInfo(props.hoveredDate);

    var month = props.month || _startDate.month || currentDateTime.month;
    var year = props.year || _startDate.year || currentDateTime.year;

    var _disabledIntervals = calendarHelper.getDisabledIntervals(props.disabledDates);

    _this.uid = props.id || (0, _unique.default)();
    _this.state = {
      startDate: _startDate,
      endDate: _endDate,
      hoveredDate: _hoveredDate,
      month: month,
      year: year,
      pickingMonth: false,
      disabledIntervals: _disabledIntervals
    };
    return _this;
  }

  _createClass(DateRangePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          withNavigation = _this$props.withNavigation,
          availableYears = _this$props.availableYears,
          disabledDates = _this$props.disabledDates,
          months = _this$props.months,
          props = _objectWithoutProperties(_this$props, ["withNavigation", "availableYears", "disabledDates", "months"]);

      var _this$state3 = this.state,
          month = _this$state3.month,
          year = _this$state3.year,
          startDate = _this$state3.startDate,
          endDate = _this$state3.endDate,
          hoveredDate = _this$state3.hoveredDate,
          pickingMonth = _this$state3.pickingMonth;
      var userStartDate = calendarHelper.createLuxonDay(startDate);
      var userEndDate = calendarHelper.createLuxonDay(endDate);
      var userHoveredDate = calendarHelper.createLuxonDay(hoveredDate);
      var calendarDate = calendarHelper.createLuxonDay({
        year: year,
        month: month,
        day: 1
      });
      return _react.default.createElement("div", {
        className: "co-datepicker",
        id: this.uid
      }, withNavigation ? _react.default.createElement(_datepickerNavigation.default, {
        id: "".concat(this.uid, "-navigation"),
        onChange: this.updateDatePicker,
        month: month,
        months: months,
        year: year.toString(),
        years: availableYears
      }) : null, !pickingMonth ? _react.default.createElement(_calendar.default, _extends({}, props, {
        date: calendarDate.toString(),
        startDate: userStartDate && userStartDate.toString(),
        endDate: userEndDate && userEndDate.toString(),
        hoveredDate: userHoveredDate && userHoveredDate.toString(),
        onClick: this.onClick,
        onMouseEnter: this.onMouseEnter,
        disabledDates: disabledDates
      })) : null);
    }
  }]);

  return DateRangePicker;
}(_react.default.Component);

DateRangePicker.propTypes = {
  id: _propTypes.string,

  /** {number} Between 1 and 12 */
  month: (0, _airbnbPropTypes.between)({
    gt: 0,
    lte: 12
  }),

  /** {object} Object with numbers (1...12) as keys and string as value. Example: {1: "January", ..., 12: "December"} */
  months: (0, _propTypes.shape)({
    1: _propTypes.string,
    2: _propTypes.string,
    3: _propTypes.string,
    4: _propTypes.string,
    5: _propTypes.string,
    6: _propTypes.string,
    7: _propTypes.string,
    8: _propTypes.string,
    9: _propTypes.string,
    10: _propTypes.string,
    11: _propTypes.string,
    12: _propTypes.string
  }),

  /** {number} */
  year: _airbnbPropTypes.nonNegativeInteger,

  /** {string} Required if @@endDate@@ is defined; Format: @@YYYY-MM-DD@@ */
  startDate: (0, _airbnbPropTypes.requiredBy)('endDate', coPropTypes.date),

  /** {string} Format: @@YYYY-MM-DD@@ */
  endDate: coPropTypes.date,

  /** {const} @@DatePicker.WEEKDAYS.[MON...SUN]@@ */
  weekStart: calendarHelper.oneOfWeekdays,

  /** {object} Object with weekdays in the format of MON...SUN as keys and a three char string as value. Example: {MON: "Mon"} */
  weekdays: (0, _propTypes.shape)({
    MON: _propTypes.string,
    TUE: _propTypes.string,
    WED: _propTypes.string,
    THU: _propTypes.string,
    FRI: _propTypes.string,
    SAT: _propTypes.string,
    SUN: _propTypes.string
  }),
  withNavigation: _propTypes.bool,

  /** {array} Array of type: @@string@@; Required if @@withNavigation@@ is defined  */
  availableYears: (0, _airbnbPropTypes.requiredBy)('withNavigation', (0, _airbnbPropTypes.uniqueArrayOf)(_propTypes.string)),
  highlightToday: _propTypes.bool,
  onChange: _propTypes.func,

  /** {array} Array of obects with the following format: [{ start: @@YYYY-MM-DD@@, end: @@YYYY-MM-DD@@ }] */
  disabledDates: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    start: coPropTypes.date.isRequired,
    end: coPropTypes.date.isRequired
  }))
};
DateRangePicker.WEEKDAYS = calendarHelper.WeekDays;
DateRangePicker.defaultProps = {
  onChange: function onChange() {}
};
var _default = DateRangePicker;
exports.default = _default;
DateRangePicker.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "isValidInterval",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "start",
      "type": null
    }, {
      "name": "end",
      "type": null
    }],
    "returns": null
  }, {
    "name": "overlapsDisabled",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "selectedDate",
      "type": null
    }],
    "returns": null
  }, {
    "name": "updateDateRange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "selectedDate",
      "type": null
    }],
    "returns": null
  }, {
    "name": "updateDatePicker",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "calendarNavigation",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onClick",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "selectedDate",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onMouseEnter",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "hoveredDate",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "DateRangePicker",
  "props": {
    "onChange": {
      "defaultValue": {
        "value": "() => { }",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "month": {
      "type": {
        "name": "custom",
        "raw": "between({ gt: 0, lte: 12 })"
      },
      "required": false,
      "description": "{number} Between 1 and 12"
    },
    "months": {
      "type": {
        "name": "shape",
        "value": {
          "1": {
            "name": "string",
            "required": false
          },
          "2": {
            "name": "string",
            "required": false
          },
          "3": {
            "name": "string",
            "required": false
          },
          "4": {
            "name": "string",
            "required": false
          },
          "5": {
            "name": "string",
            "required": false
          },
          "6": {
            "name": "string",
            "required": false
          },
          "7": {
            "name": "string",
            "required": false
          },
          "8": {
            "name": "string",
            "required": false
          },
          "9": {
            "name": "string",
            "required": false
          },
          "10": {
            "name": "string",
            "required": false
          },
          "11": {
            "name": "string",
            "required": false
          },
          "12": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "{object} Object with numbers (1...12) as keys and string as value. Example: {1: \"January\", ..., 12: \"December\"}"
    },
    "year": {
      "type": {
        "name": "custom",
        "raw": "nonNegativeInteger"
      },
      "required": false,
      "description": "{number}"
    },
    "startDate": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('endDate', coPropTypes.date)"
      },
      "required": false,
      "description": "{string} Required if @@endDate@@ is defined; Format: @@YYYY-MM-DD@@"
    },
    "endDate": {
      "type": {
        "name": "custom",
        "raw": "coPropTypes.date"
      },
      "required": false,
      "description": "{string} Format: @@YYYY-MM-DD@@"
    },
    "weekStart": {
      "type": {
        "name": "custom",
        "raw": "calendarHelper.oneOfWeekdays"
      },
      "required": false,
      "description": "{const} @@DatePicker.WEEKDAYS.[MON...SUN]@@"
    },
    "weekdays": {
      "type": {
        "name": "shape",
        "value": {
          "MON": {
            "name": "string",
            "required": false
          },
          "TUE": {
            "name": "string",
            "required": false
          },
          "WED": {
            "name": "string",
            "required": false
          },
          "THU": {
            "name": "string",
            "required": false
          },
          "FRI": {
            "name": "string",
            "required": false
          },
          "SAT": {
            "name": "string",
            "required": false
          },
          "SUN": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "{object} Object with weekdays in the format of MON...SUN as keys and a three char string as value. Example: {MON: \"Mon\"}"
    },
    "withNavigation": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "availableYears": {
      "type": {
        "name": "custom",
        "raw": "requiredBy('withNavigation', uniqueArrayOf(string))"
      },
      "required": false,
      "description": "{array} Array of type: @@string@@; Required if @@withNavigation@@ is defined"
    },
    "highlightToday": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabledDates": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "start": {
              "name": "custom",
              "raw": "coPropTypes.date.isRequired",
              "required": true
            },
            "end": {
              "name": "custom",
              "raw": "coPropTypes.date.isRequired",
              "required": true
            }
          }
        }
      },
      "required": false,
      "description": "{array} Array of obects with the following format: [{ start: @@YYYY-MM-DD@@, end: @@YYYY-MM-DD@@ }]"
    }
  }
};